import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ onLogout }) => {
  const location = useLocation();
  const [isNavOpen, setIsNavOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  const closeNav = () => setIsNavOpen(false);

  return (
    <nav 
      className="navbar navbar-expand-lg navbar-light shadow-sm" 
      style={{ backgroundColor: '#ffffff', padding: '0.8rem 2rem' }}
    >
      <div className="container-fluid">
        
        {/* --- BRANDING --- */}
        <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeNav}>
          <img 
            src="https://ik.imagekit.io/nanoplex/Project%20Image/NSFDC/nsfdclogo-removebg-preview_aCQYROM-P.png?updatedAt=1763554348489" 
            alt="Logo" 
            style={{ height: '65px', marginRight: '10px' }} 
          />
          <div className="d-flex flex-column justify-content-center">
            <div 
              className="fw-bolder" 
              style={{ 
                fontSize: '1.35rem', 
                color: '#0D1B5E', 
                lineHeight: '1', 
                letterSpacing: '-0.5px',
                fontFamily: "'Segoe UI', sans-serif"
              }}
            >
              NSFDC-BEAM
            </div>
            <div 
              className="text-uppercase fw-bold" 
              style={{ 
                color: '#000000', 
                fontSize: '0.75rem', 
                letterSpacing: '3px',
                marginTop: '4px',
                opacity: 0.8
              }}
            >
              Admin Portal
            </div>
          </div>
        </Link>

        {/* --- MOBILE TOGGLER --- */}
        <button 
          className="navbar-toggler border-0" 
          type="button" 
          onClick={() => setIsNavOpen(!isNavOpen)}
          aria-controls="navbarNav"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* --- NAVIGATION LINKS --- */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center text-center">
            
            <NavItem to="/loans" label="Loan Inquiries" active={isActive('/loans')} onClick={closeNav} />
            <NavItem to="/skills" label="Skill Dev" active={isActive('/skills')} onClick={closeNav} />
            <NavItem to="/workshops" label="Workshops" active={isActive('/workshops')} onClick={closeNav} />
            <NavItem to="/exhibitions" label="Exhibitions" active={isActive('/exhibitions')} onClick={closeNav} />

            {/* --- NEW SLIDER LINK --- */}
            <NavItem 
              to="/sliders" 
              label="App Sliders" 
              active={isActive('/sliders')} 
              onClick={closeNav} 
            />
            {/* ----------------------- */}

            <NavItem to="/users" label="User Mgmt" active={isActive('/users')} onClick={closeNav} />

            <li className="nav-item mx-2 d-none d-lg-block text-secondary">|</li>

            <li className="nav-item ms-lg-2 mt-3 mt-lg-0">
              <button 
                className="btn btn-warning btn-sm fw-bold px-3" 
                onClick={() => { closeNav(); onLogout(); }}
                style={{ borderRadius: '20px' }}
              >
                <i className="bi bi-box-arrow-right me-1"></i> Logout
              </button>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  );
};

const NavItem = ({ to, label, active, onClick }) => (
  <li className="nav-item mx-1 my-1 my-lg-0">
    <Link 
      className={`nav-link ${active ? 'active fw-bold' : ''}`} 
      to={to}
      onClick={onClick}
      style={{ 
        color: active ? '#000000' : 'rgba(0, 0, 0, 0.7)', 
        borderBottom: active ? '2px solid #FF9933' : '2px solid transparent', 
        transition: 'all 0.3s'
      }}
    >
      {label}
    </Link>
  </li>
);

export default Navbar;